import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "media-styles-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.6408 6.5812C10.6408 6.22717 10.3538 5.94017 9.99977 5.94017C9.64574 5.94017 9.35875 6.22717 9.35875 6.5812V9.35897H6.58097C6.22694 9.35897 5.93994 9.64597 5.93994 10C5.93994 10.354 6.22694 10.641 6.58097 10.641H9.35875V13.4188C9.35875 13.7728 9.64574 14.0598 9.99977 14.0598C10.3538 14.0598 10.6408 13.7728 10.6408 13.4188V10.641H13.4186C13.7726 10.641 14.0596 10.354 14.0596 10C14.0596 9.64597 13.7726 9.35897 13.4186 9.35897H10.6408V6.5812Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.66667 1.875C4.0203 1.875 1.875 4.0203 1.875 6.66667V13.3333C1.875 15.9797 4.0203 18.125 6.66667 18.125H13.3333C15.9797 18.125 18.125 15.9797 18.125 13.3333V6.66667C18.125 4.0203 15.9797 1.875 13.3333 1.875H6.66667ZM3.125 6.66667C3.125 4.71066 4.71066 3.125 6.66667 3.125H13.3333C15.2893 3.125 16.875 4.71066 16.875 6.66667V13.3333C16.875 15.2893 15.2893 16.875 13.3333 16.875H6.66667C4.71066 16.875 3.125 15.2893 3.125 13.3333V6.66667Z"
    }, null, -1)
  ])))
}
export default { render: render }